export default __webpack_public_path__ + "static/media/stethoscope.fd3fa5d7.png";